export const PatientList = [
    {
        id: 1,
        activeDoc: "Марченко Сергій Віталійович",
        age: "25",
        biopsiya: "Первинна",
        cardNumber: "12341251",
        clinicalConclusion: "Перелом ноги",
        clinicalInfo: "Обмежено придатний",
        department: "Травматологія",
        gender: "Ч",
        hospital: "Лікарня №2",
        markedMaterial: "Біопсія",
        operationDateName: "2024-09-12",
        operationName: "Лапороскопія",
        patientName: "Каналенко Ігор Валерійович",
        patientNumber: "45901267",
        phoneNmber: "+380931194691",
        quantityMaterial: "1",
        research: "ІГХ"
    },
    {
        id: 2,
        activeDoc: "Іваненко Олег Михайлович",
        age: "30",
        biopsiya: "Повторна",
        cardNumber: "23123451",
        clinicalConclusion: "Травма спини",
        clinicalInfo: "Придатний",
        department: "Неврологія",
        gender: "Ч",
        hospital: "Лікарня №1",
        markedMaterial: "МРТ",
        operationDateName: "2024-09-15",
        operationName: "Хірургія",
        patientName: "Ковальчук Дмитро Васильович",
        patientNumber: "49102468",
        phoneNmber: "+380671984532",
        quantityMaterial: "2",
        research: "КТ"
    },
    {
        id: 3,
        activeDoc: "Петренко Ольга Іванівна",
        age: "45",
        biopsiya: "Первинна",
        cardNumber: "43551234",
        clinicalConclusion: "Перелом ребра",
        clinicalInfo: "Обмежено придатний",
        department: "Ортопедія",
        gender: "Ж",
        hospital: "Лікарня №3",
        markedMaterial: "Рентген",
        operationDateName: "2024-09-18",
        operationName: "Фіксація кісток",
        patientName: "Василенко Олена Сергіївна",
        patientNumber: "40189234",
        phoneNmber: "+380501234567",
        quantityMaterial: "1",
        research: "Рентген"
    },
    {
        id: 4,
        activeDoc: "Сидоренко Ігор Степанович",
        age: "37",
        biopsiya: "Повторна",
        cardNumber: "29812345",
        clinicalConclusion: "Гепатит",
        clinicalInfo: "Придатний",
        department: "Гастроентерологія",
        gender: "Ч",
        hospital: "Лікарня №4",
        markedMaterial: "Біопсія печінки",
        operationDateName: "2024-09-20",
        operationName: "Операція печінки",
        patientName: "Павленко Максим Олександрович",
        patientNumber: "46912058",
        phoneNmber: "+380931987654",
        quantityMaterial: "3",
        research: "ІГХ"
    },
    {
        id: 5,
        activeDoc: "Гриценко Анна Володимирівна",
        age: "50",
        biopsiya: "Третинна",
        cardNumber: "18345123",
        clinicalConclusion: "Артрит",
        clinicalInfo: "Обмежено придатний",
        department: "Ревматологія",
        gender: "Ж",
        hospital: "Лікарня №2",
        markedMaterial: "УЗД суглобів",
        operationDateName: "2024-09-25",
        operationName: "Операція суглобів",
        patientName: "Кузьменко Марія Михайлівна",
        patientNumber: "49231056",
        phoneNmber: "+380932345678",
        quantityMaterial: "1",
        research: "ІГХ"
    },
    {
        id: 6,
        activeDoc: "Коваленко Андрій Олександрович",
        age: "33",
        biopsiya: "Первинна",
        cardNumber: "12983745",
        clinicalConclusion: "Пневмонія",
        clinicalInfo: "Придатний",
        department: "Пульмонологія",
        gender: "Ч",
        hospital: "Лікарня №1",
        markedMaterial: "КТ грудної клітки",
        operationDateName: "2024-09-30",
        operationName: "Операція легень",
        patientName: "Олійник Артем Володимирович",
        patientNumber: "49213475",
        phoneNmber: "+380991234567",
        quantityMaterial: "2",
        research: "КТ"
    },
    {
        id: 7,
        activeDoc: "Мельниченко Олександр Петрович",
        age: "28",
        biopsiya: "Первинна",
        cardNumber: "56789123",
        clinicalConclusion: "Перелом ключиці",
        clinicalInfo: "Обмежено придатний",
        department: "Ортопедія",
        gender: "Ч",
        hospital: "Лікарня №2",
        markedMaterial: "Рентген",
        operationDateName: "2024-10-02",
        operationName: "Фіксація ключиці",
        patientName: "Захаренко Іван Петрович",
        patientNumber: "45903467",
        phoneNmber: "+380501234678",
        quantityMaterial: "1",
        research: "Рентген"
    },
    {
        id: 8,
        activeDoc: "Даниленко Марина Миколаївна",
        age: "42",
        biopsiya: "Повторна",
        cardNumber: "89123456",
        clinicalConclusion: "Глаукома",
        clinicalInfo: "Придатний",
        department: "Офтальмологія",
        gender: "Ж",
        hospital: "Лікарня №3",
        markedMaterial: "Офтальмоскопія",
        operationDateName: "2024-10-05",
        operationName: "Операція на оці",
        patientName: "Савченко Галина Степанівна",
        patientNumber: "49214023",
        phoneNmber: "+380673214567",
        quantityMaterial: "1",
        research: "Офтальмологічний аналіз"
    },
    {
        id: 9,
        activeDoc: "Бойко Юрій Андрійович",
        age: "60",
        biopsiya: "Третинна",
        cardNumber: "43219876",
        clinicalConclusion: "Інсульт",
        clinicalInfo: "Обмежено придатний",
        department: "Неврологія",
        gender: "Ч",
        hospital: "Лікарня №4",
        markedMaterial: "КТ головного мозку",
        operationDateName: "2024-10-10",
        operationName: "Операція на мозку",
        patientName: "Шевченко Василь Олегович",
        patientNumber: "49321234",
        phoneNmber: "+380934567890",
        quantityMaterial: "1",
        research: "КТ"
    },
    {
        id: 10,
        activeDoc: "Романенко Оксана Вікторівна",
        age: "34",
        biopsiya: "Повторна",
        cardNumber: "98712345",
        clinicalConclusion: "Міома",
        clinicalInfo: "Придатний",
        department: "Гінекологія",
        gender: "Ж",
        hospital: "Лікарня №1",
        markedMaterial: "УЗД органів",
        operationDateName: "2024-10-12",
        operationName: "Гістеректомія",
        patientName: "Петренко Тетяна Миколаївна",
        patientNumber: "49234678",
        phoneNmber: "+380932567891",
        quantityMaterial: "2",
        research: "УЗД"
    }
];
